<template>
  <div class="message">
    <div v-if="type === 'success'">
      <svg viewBox="0 0 130.2 130.2">
        <circle
          class="path circle"
          fill="none"
          stroke="#0DC59D"
          stroke-width="8"
          stroke-miterlimit="10"
          cx="65.1"
          cy="65.1"
          r="51.1"
        />
        <polyline
          class="path check"
          fill="none"
          stroke="#0DC59D"
          stroke-width="8"
          stroke-linecap="round"
          stroke-miterlimit="10"
          points="80.2,50.2 61.5,78.8 49.8,67.5 "
        />
      </svg>
      <p class="success">{{ text }}</p>
    </div>
    <div v-else>
      <svg viewBox="0 0 130.2 130.2">
        <circle
          class="path circle"
          fill="none"
          stroke="#D06079"
          stroke-width="6"
          stroke-miterlimit="10"
          cx="65.1"
          cy="65.1"
          r="62.1"
        />
        <line
          class="path line"
          fill="none"
          stroke="#D06079"
          stroke-width="6"
          stroke-linecap="round"
          stroke-miterlimit="10"
          x1="34.4"
          y1="37.9"
          x2="95.8"
          y2="92.3"
        />
        <line
          class="path line"
          fill="none"
          stroke="#D06079"
          stroke-width="6"
          stroke-linecap="round"
          stroke-miterlimit="10"
          x1="95.8"
          y1="38"
          x2="34.4"
          y2="92.2"
        />
      </svg>
      <p class="error">{{ text }}</p>
    </div>
  </div>
</template>
<script>
export default {
  props: {
    text: { type: String, required: true },
    type: { type: String, default: "success" },
  },
};
</script>
<style scoped>
.message {
  width: 100%;
  background: rgb(13 197 157 / 10%);
  border-radius: 5px;
  margin-bottom: 25px;
  display: flex;
  padding: 25px 40px;
}
.message p {
  text-align: center;
  font-size: 1.4em;
  font-weight: bold;
  line-height: 17px;
}
svg {
  width: 50px;
  display: block;
  margin: 0 auto;
}
.path {
  stroke-dasharray: 1000;
  stroke-dashoffset: 0;
}
.path.circle {
  -webkit-animation: dash 0.9s ease-in-out;
  animation: dash 0.9s ease-in-out;
}
.path.line {
  stroke-dashoffset: 1000;
  -webkit-animation: dash 0.9s 0.35s ease-in-out forwards;
  animation: dash 0.9s 0.35s ease-in-out forwards;
}
.path.check {
  stroke-dashoffset: -100;
  -webkit-animation: dash-check 0.9s 0.35s ease-in-out forwards;
  animation: dash-check 0.9s 0.35s ease-in-out forwards;
}
p {
  text-align: center;
  margin-top: 20px;
  font-size: 1.2em;
}
p.success {
  color: #0dc59d;
}
p.error {
  color: #d06079;
}
@-webkit-keyframes dash {
  0% {
    stroke-dashoffset: 1000;
  }
  100% {
    stroke-dashoffset: 0;
  }
}
@keyframes dash {
  0% {
    stroke-dashoffset: 1000;
  }
  100% {
    stroke-dashoffset: 0;
  }
}
@-webkit-keyframes dash-check {
  0% {
    stroke-dashoffset: -100;
  }
  100% {
    stroke-dashoffset: 900;
  }
}
@keyframes dash-check {
  0% {
    stroke-dashoffset: -100;
  }
  100% {
    stroke-dashoffset: 900;
  }
}
</style>
